/**
 * Top nav — brand wordmark (from MARKETING.brand) on the left, marketing
 * links + Foundations CTA on the right. Pure presentational; no state, no
 * callbacks.
 *
 * Locked structure per docs/design-references/calc-page-approved.json:
 *   wordmark | nav links | sage Foundations button
 *
 * MARKETING.topNav drives the link list — adding/removing a link is a
 * src/marketing.ts edit, never a header.ts edit.
 */

import { el } from "../dom";
import { MARKETING } from "../marketing";

import "./header.css";

export interface HeaderHandle {
  el: HTMLElement;
}

export function createHeader(): HeaderHandle {
  const wordmark = el(
    "a",
    {
      href: "/",
      class: "header__wordmark",
      "aria-label": MARKETING.brand.homeAriaLabel,
    },
    MARKETING.brand.wordmark,
  );

  const links = MARKETING.topNav.map((link) =>
    el(
      "a",
      {
        href: link.url,
        class: "header__link",
        target: "_blank",
        rel: "noopener noreferrer",
      },
      link.label,
    ),
  );

  const cta = el(
    "a",
    {
      href: MARKETING.topNavCTA.url,
      class: "header__cta",
      target: "_blank",
      rel: "noopener noreferrer",
    },
    MARKETING.topNavCTA.label,
  );

  const nav = el(
    "nav",
    { class: "header__nav", "aria-label": MARKETING.topNavAriaLabel },
    ...links,
    cta,
  );

  const root = el(
    "header",
    { class: "header no-print", role: "banner" },
    el("div", { class: "container header__inner" }, wordmark, nav),
  );

  return { el: root };
}
